const BASEURL = "https://api2.smartinb.ai";
export const DataBaseName = "kai";
export const getCaseInfo_endPoint = "/api/manitcase/maintenancecase";

export default BASEURL;
